// Export/import del check-up come file JSON locale.
// Nessuna chiamata di rete: i dati restano sul dispositivo dell'utente.

const APP_ID = 'stipendee-check-up';
const SCHEMA = 1;

function formatDateForFilename(date) {
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

/** Scarica le risposte come file JSON, con voto e data per poter confrontare in futuro. */
export function downloadBackup(data, score) {
  const now = new Date();
  const backup = {
    app: APP_ID,
    schema: SCHEMA,
    savedAt: now.toISOString(),
    score: score ? { total: score.total, level: score.level?.name || null } : null,
    data
  };

  const blob = new Blob([JSON.stringify(backup, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `check-up-finanziario-${formatDateForFilename(now)}.json`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

/**
 * Legge un file di backup e lo valida.
 * Risolve con { data, score, savedAt } oppure rigetta con un messaggio leggibile.
 */
export function readBackupFile(file) {
  return new Promise((resolve, reject) => {
    if (!file) {
      reject(new Error('Nessun file selezionato.'));
      return;
    }
    if (file.size > 2 * 1024 * 1024) {
      reject(new Error('Il file è troppo grande per essere un backup del check-up.'));
      return;
    }

    const reader = new FileReader();
    reader.onerror = () => reject(new Error('Non è stato possibile leggere il file.'));
    reader.onload = () => {
      let parsed;
      try {
        parsed = JSON.parse(String(reader.result));
      } catch (error) {
        reject(new Error('Questo file non è leggibile: assicurati di caricare il .json scaricato dal check-up.'));
        return;
      }

      if (!parsed || parsed.app !== APP_ID || !parsed.data || typeof parsed.data !== 'object') {
        reject(new Error('Questo non sembra un backup del check-up finanziario di Stipendee.'));
        return;
      }
      if (Number(parsed.schema) > SCHEMA) {
        reject(new Error('Questo backup è stato creato con una versione più recente del check-up.'));
        return;
      }

      resolve({
        data: parsed.data,
        score: parsed.score || null,
        savedAt: parsed.savedAt || null
      });
    };
    reader.readAsText(file);
  });
}

/** "14 luglio 2026" a partire da una data ISO. */
export function formatBackupDate(iso) {
  if (!iso) return null;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  return new Intl.DateTimeFormat('it-IT', { day: 'numeric', month: 'long', year: 'numeric' }).format(date);
}
